import React, { Fragment } from 'react';

const FourParticipants = () => {
  return (
    <Fragment>
      <div className="participants-panel">
        <div className="participant">
          <div className="participant-avi"></div>
          <p className="participant-name">User Name</p>
        </div>
        <div className="participant">
          <div className="participant-avi"></div>
          <p className="participant-name">User Name</p>
        </div>
        <div className="participant">
          <div className="participant-avi"></div>
          <p className="participant-name">User Name</p>
        </div>
        <div className="participant">
          <div className="participant-avi"></div>
          <p className="participant-name">User Name</p>
        </div>
      </div>
    </Fragment>
  );
};

export default FourParticipants;
